// extracted by mini-css-extract-plugin
export var banner = "_j4-0";
export var closeButton = "_j4-2";
export var greenCheckmark = "_j4-3";
export var hereLink = "_j4-4";
export var titleIcon = "_j4-1";